module.exports = {
    requestInProgress: {
        errorTitle: 'contractsView-upgradeToNominaRequsetInProgressErrorTitle',
        errorBody: 'contractsView-upgradeToNominaRequsetInProgressErrorBody',
        backButtonLabel: 'contractsView-errorBackButtonLabelGlobal',
        backButtonLink: '/myprofile/global'
    }
}
